const state =
    {
        translations: {},
        activeShippingCountries: [],
        activeShopLanguageList: [],
        currentShippingCountryId: 1,
        shopLanguage: "de"
    };

const mutations =
    {
        setTranslation(state, payload)
        {
            state.translations = payload;
        },
        setLocalizationData(state, payload)
        {
            state.activeShippingCountries = payload.activeShippingCountries;
            state.activeShopLanguageList = payload.activeShopLanguageList;
            state.currentShippingCountryId = payload.currentShippingCountryId;
            state.shopLanguage = payload.shopLanguage;
        }
    };

const getters =
    {
        getTranslation: state => key =>
        {
            const word = state.translations[key];

            if (word && word.length > 0)
            {
                return word;
            }
            return "";
        },

        getCountryObjectById: state => countryId =>
        {
            if (countryId > 0)
            {
                const country = state.activeShippingCountries.find(country => country.id === parseInt(countryId));

                if (country)
                {
                    return country;
                }
            }
            return {};
        },

        getCountryName: state => countryId =>
        {
            if (countryId > 0)
            {
                const country = state.activeShippingCountries.find(country => country.id === countryId);

                // eslint-disable-next-line
                if (country !== null && typeof country === typeof void 0)
                {
                    return country.currLangName;
                }
            }
            return "";
        }
    };

export default
{
    state,
    mutations,
    getters
};
